import { createContext } from 'react';
import { Nullable } from 'global';
import { Engine, EngineResult } from 'json-rules-engine';
import { ProposalProduct } from '@trnsact/trnsact-shared-types/dist/generated';
import { FailedRule } from '../../types';

interface JsonRulesEngineContext {
  engine: Engine;
  failedRules: FailedRule[];
  handleRunEngin: VoidFunction;
  analyzeFailureResults: (engineResults: EngineResult) => void;
  handleAddProductsRules: (product: ProposalProduct) => void;
}

export const jsonRulesEngineContext = createContext<Nullable<JsonRulesEngineContext>>(null);
